import DealerMapper from '../../../../../utils/dealer-mapper.js';

export default class PreferredDealerSubview {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.preferred-dealer');
        this.dealerUrl = this.parent.dealerUrl;
        this.card = this.el.querySelector('.card');
        this.dealerTemplate = _.template(parent.el.querySelector('#preferred-dealer').innerHTML.replaceAll('\\', ''));
        this.noDealerTemplate = _.template(parent.el.querySelector('#no-dealer').innerHTML.replaceAll('\\', ''));
    }

    async populate() {
        const details = await window.HONDA.MyAccount2.client.getPersonalDetails();
        const dealer = details?.preferredDealercode;
        const result = dealer ? await window.HONDA.MyAccount2.client.getDealerDetails(this.dealerUrl, dealer) : null;
        const data = result ? DealerMapper.map(result) : null;
        this.card.innerHTML = data ? this.dealerTemplate({ dealer: data }) : this.noDealerTemplate();
        this.parent.update();
    }
}
